module.exports = __webpack_public_path__ + "fonts/800-normal-latin-ext.54b8921.woff2";